/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useEffect, useState } from 'react';
import { Alert, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, List, ListItem, Paper, Snackbar, SnackbarCloseReason, TextField, useTheme, Typography } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { BasicSelect, VFieldMoney, VForm, VTextFieldNumber, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { VFieldMoney4Faturamento } from './VFieldMoney4Faturamento';
import { useNavigate } from 'react-router-dom';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { VFieldMoney2Faturamento } from './VFieldMoney2Faturamento';
import { MovimentoService } from '../../../shared/services/api/estoque/movimento/MovimentoService';
import { TelaBloqueioSalvando } from '../../../shared/components';
import { useBloqueioSalvamento } from '../../../shared/hooks';

interface IFormDataCabecalho {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  numero: string;
  emissao: string;
  vprod: number;
  desconto: number;
  total: number;
  acrescimo: number;
}
interface IitensEntradaDialog {
  iditens: string;
  idprodutos: string;
  idref: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  subtotal: number;
  desconto: number;
  voutros: number;
  total: number;
  filtro: string;
  ean?: string;
  localizado?: string;
  original?: boolean;
  referencia?: string;
  marca?: string;
  descricao: string;
}
interface IParcelasFaturamento {
  idpagar: string;
  idplanoconta: string;
  idparceiro: string;
  emissao: string;
  vencimento: string;
  numero: string;
  tipo: number;
  parcela: string;
  vpagar: number;
  desconto: number;
  acrescimo: number;
  vpago: number;
  vparcela: number;
  tipopagamento: string;
  historico: string;
  qtdparcelas: number;
  vcompra: number;
}
interface IItensids {
  iditens: string;
}
export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  open: boolean;
  status: boolean;
  operacao?: string;
  dados?: IFormDataCabecalho;
  dadosItens?: IitensEntradaDialog[];
  iddeletados?: IItensids[];
  decimais: number;
  iduser?: string;
  onClose: (value?: string) => void;
}

const formValidationSchema: yup.ObjectSchema<IParcelasFaturamento> = yup.object().shape({
  vencimento: yup.string().required(),
  emissao: yup.string().required(),
  idpagar: yup.string().required(),
  idplanoconta: yup.string().required(),
  idparceiro: yup.string().required(),
  tipopagamento: yup.string().required(),
  numero: yup.string().optional().default(''),
  tipo: yup.number().optional().default(1),
  vpago: yup.number().optional().default(10),
  parcela: yup.string().optional().default(''),
  vparcela: yup.number().optional().default(1),
  vpagar: yup.number().optional().default(0),
  desconto: yup.number().optional().default(0),
  vcompra: yup.number().required(),
  juros: yup.number().optional().default(0),
  historico: yup.string().required(),
  acrescimo: yup.number().optional().default(1),
  status: yup.boolean().optional().default(false),
  qtdparcelas: yup.number().optional().default(1),
});

export const DialogFaturamento: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { formRef, save } = useVForm();
  const { onClose, value: valueProp, open, ...other } = props;
  const [, setValue] = useState(valueProp);
  const [isLoading, setIsLoading] = useState(false);
  const { isSaving, progress: saveProgress, iniciar: iniciarSalvamento, concluir: concluirSalvamento, cancelar: cancelarSalvamento } = useBloqueioSalvamento();
  const [id, setId] = useState('');
  const [lista, setLista] = useState<IParcelasFaturamento[]>([]);
  const [, setAtualizarLista] = useState<{ idpagar: string; vparcela: number; }[]>([]);
  const [diferenca, setDiferenca] = useState<number>(0);

  const itensnovo = {
    venda: props.dados?.total,
    pagamento: 'carteira',
    numero: props.dados?.numero,
    vencimento: '',
    qtdparcelas: 1,
  };

  useEffect(() => {
    formRef.current?.setData(itensnovo);
    setQtdParcelas(1);
  }, [id, formRef]);

  const [valornota, setvalornota] = useState(props.dados?.total);
  const [qtdParcelas, setQtdParcelas] = useState(1);
  const [tipopagamento, setTipopagamento] = useState('carteira');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  useEffect(() => {
    const totalParcelas = lista.reduce((acc, item) => acc + item.vparcela, 0);
    const valorNota = valornota || 0;
    const diff = totalParcelas - valorNota;
    setDiferenca(diff);
  }, [lista, valornota]);
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const tag = (event.target as HTMLElement).tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;

      if (event.key === 'F9') {
        event.preventDefault();
        save();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [save]);
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      onClose();
      navigate(`/entrada/${props.dados?.idmov}`);
    }
  };
  const handleCancel = () => {
    onClose();
  };
  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    } else {
      setId(valueProp);
    }
    setvalornota(props.dados?.total);
  }, [valueProp, open]);

  const handleVnota = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/\./g, '');
      valor = valor.replace(/,/g, '.');
      valor = valor.replace(/(\d)(\d{4})$/, '$1.$2');
      valor = valor.replace(/(?=(\d{3})+(\D))\B/g, '');
      setvalornota(Number(valor));
    }
  };
  const handleQtdParcelas = (valor: string | undefined) => {
    if (valor != null) {
      setQtdParcelas(Number(valor));
    }
  };
  const handleTipopagamento = (valor: string | undefined) => {
    if (valor != null) {
      setTipopagamento(valor);
    }
  };
  const roundToDecimals = (value: number): number => {
    const factor = Math.pow(10, props.decimais);
    return Math.round(value * factor) / factor;
  };
  useEffect(() => {
    setLista([]);
    let valorparcela = valornota! / qtdParcelas;
    valorparcela = roundToDecimals(valorparcela);

    for (let i = 0; i < qtdParcelas; i++) {
      const dataVencimento = new Date();
      const diasParaAdicionar = 30 + (i * 30);
      dataVencimento.setDate(dataVencimento.getDate() + diasParaAdicionar);
      const ops = {
        idpagar: uuidv4(),
        idplanoconta: props.dados?.idplanoconta || '',
        idparceiro: props.dados?.idparceiro || '',
        numero: props.dados?.numero || '',
        emissao: String(
          props.dados?.emissao ??
          dayjs().tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss')
        ),
        tipopagamento: tipopagamento || '',
        vencimento: dayjs(dataVencimento).format('YYYY-MM-DD'),
        vparcela: valorparcela,
        vcompra: valornota ?? 0,
        parcela: `${i + 1}/${qtdParcelas}`,
        vpago: 0,
        historico: 'Entrada de Mercadoria',
        vpagar: valorparcela,
        tipo: 1,
        desconto: 0,
        acrescimo: 0,
        qtdparcelas: qtdParcelas,
      };
      setLista((oldLista) => [...oldLista, ops]);
    }
  }, [valornota, tipopagamento, qtdParcelas, open, props.decimais]);

  const formatValue = (inputValue: string | number): string => {
    let formattedValue: string;
    if (typeof inputValue === 'number') {
      inputValue = inputValue.toString();
    }
    if (!inputValue.includes('.')) {
      formattedValue = inputValue.replace(/\D/g, '');
      const zeros = props.decimais === 4 ? '0000' : '00';
      formattedValue += ',' + zeros;
      formattedValue = formattedValue.replace(/(\d)(?=(\d{3})+(,))/g, '$1.');
    } else {
      formattedValue = inputValue.replace(/\./g, ',');
      const decimalDigits = props.decimais === 4 ? 4 : 2;
      formattedValue = formattedValue.replace(new RegExp(`(\\d+,\\d{0,${decimalDigits}})\\d*`), '$1');
      formattedValue = formattedValue.replace(/(\d)(?=(\d{3})+(,))/g, '$1.');
    }
    return formattedValue;
  };

  const formatarMoeda = (valor: number): string => {
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: props.decimais,
      maximumFractionDigits: props.decimais
    });
  };

  const handleSave = useCallback(() => {
    if (!iniciarSalvamento()) return;

    if (!props.dados || !props.dadosItens) {
      cancelarSalvamento();
      setTms('error');
      setMsg('Dados incompletos para salvar');
      setOpenmsg(true);
      return;
    }
    const totalSum = lista.reduce((acc, item) => acc + item.vparcela, 0);
    const tolerance = 0.0001;

    if (Math.abs(totalSum - props.dados.total) > tolerance) {
      cancelarSalvamento();
      setTms('error');
      setMsg(`Valor Total das Parcelas não Confere: ${formatarMoeda(totalSum)}`);
      setOpenmsg(true);
      return;
    }

    formValidationSchema.validate(lista[0], { abortEarly: false })
      .then(() => {
        setIsLoading(true);
        const saveOperation = props.id === 'novo'
          ? MovimentoService.create(
            props.dados as IFormDataCabecalho,
            props.dadosItens!,
            lista
          )
          : MovimentoService.updateById(
            props.id,
            props.dados as IFormDataCabecalho,
            props.dadosItens!,
            props.iddeletados || [],
            lista
          );

        saveOperation.then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            cancelarSalvamento();
            setTms('error');

            try {
              const errorObj = JSON.parse(result.message);

              const mensagem =
                errorObj?.errors?.['[0].numero'] ||
                'Erro ao salvar';

              setMsg(mensagem);
            } catch {
              setMsg(result.message);
            }

          } else {
            setTms('success');
            setMsg(props.id === 'novo'
              ? 'Lançamento Realizado com sucesso!'
              : 'Alteração concluída com sucesso!');
            concluirSalvamento();
          }
          setOpenmsg(true);
        });
      })
      .catch(() => {
        cancelarSalvamento();
      });
  }, [lista, props.dados, props.dadosItens, props.iddeletados, props.id, iniciarSalvamento, cancelarSalvamento, concluirSalvamento]);

  const handleInputChange = useCallback((id: string, valor: string) => {
    const updatedList = lista.map((listItem) => {
      if (listItem.idpagar === id) {
        const novoValor = roundToDecimals(Number(valor));
        const novoObjeto = { idpagar: id, vparcela: novoValor };
        setAtualizarLista(prevLista => [...prevLista, novoObjeto]);
        return {
          ...listItem,
          vpagar: novoValor,
          vparcela: novoValor,
        };
      } else {
        return listItem;
      }
    });

    setLista(updatedList);
  }, [lista, props.decimais]);

  const handleInputChangeDate = useCallback((id: string, valor: string) => {
    const updatedList = lista.map((listItem) => {
      if (listItem.idpagar === id) {
        return {
          ...listItem,
          vencimento: valor,
        };
      } else {
        return listItem;
      }
    });
    setAtualizarLista(updatedList);
    setLista(updatedList);
  }, [lista]);
  const getHeaderGradient = () => {
    if (theme.palette.mode === 'dark') {
      return 'linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)';
    }
    return 'linear-gradient(135deg, #1976D2 0%, #1565C0 100%)';
  };

  const getBackgroundColor = () => {
    if (theme.palette.mode === 'dark') {
      return '#1E1E2F';
    }
    return '#F8FAFC';
  };

  const getCardBackgroundColor = () => {
    if (theme.palette.mode === 'dark') {
      return '#2D2D44';
    }
    return '#FFFFFF';
  };

  const getInputBackgroundColor = () => {
    if (theme.palette.mode === 'dark') {
      return '#2D2D44';
    }
    return '#F8FAFC';
  };

  const getBorderColor = () => {
    if (theme.palette.mode === 'dark') {
      return 'rgba(25, 118, 210, 0.3)';
    }
    return 'rgba(25, 118, 210, 0.1)';
  };

  const getIconColor = () => {
    if (theme.palette.mode === 'dark') {
      return '#90CAF9';
    }
    return '#94A3B8';
  };

  const getTextColor = () => {
    if (theme.palette.mode === 'dark') {
      return '#E0E0E0';
    }
    return '#1E293B';
  };

  const isConfirmDisabled = Math.abs(diferenca) > 0.0001;

  return (
    <>
      <TelaBloqueioSalvando
        open={isSaving}
        message="Salvando faturamento..."
        progress={saveProgress}
      />
      <Dialog
      open={open}
      {...other}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
          boxShadow: theme.palette.mode === 'dark'
            ? '0 20px 40px rgba(0,0,0,0.4)'
            : '0 20px 40px rgba(0,0,0,0.15)',
          maxHeight: '90vh',
        }
      }}
    >
      {/* HEADER COM GRADIENTE */}
      <Box sx={{
        background: getHeaderGradient(),
        p: 2,
        px: 2.5,
      }}>
        <DialogTitle sx={{
          p: 0,
          color: 'white',
          fontWeight: 600,
          fontSize: 20,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <ReceiptIcon sx={{ fontSize: 22 }} />
          Faturamento
        </DialogTitle>
      </Box>

      <DialogContent
        dividers
        sx={{
          p: 2.5,
          bgcolor: getBackgroundColor(),
          '&.MuiDialogContent-dividers': {
            borderColor: theme.palette.mode === 'dark'
              ? 'rgba(255,255,255,0.12)'
              : 'rgba(0,0,0,0.08)'
          }
        }}
      >
        <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openmsg}
            autoHideDuration={tms === 'error' ? null : 1200}
            onClose={handleCloseMsg}
          >
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{
                width: '100%',
                borderRadius: 2,
                boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
              }}
            >
              {msg}
            </Alert>
          </Snackbar>

          {/* ALERTA DE DIFERENÇA ENTRE PARCELAS E TOTAL */}
          {Math.abs(diferenca) > 0.0001 && (
            <Alert
              severity="warning"
              icon={<WarningIcon />}
              sx={{
                mb: 2,
                borderRadius: 2,
                '& .MuiAlert-message': {
                  width: '100%'
                }
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                <Typography variant="body2" fontWeight="bold">
                  ⚠️ A soma das parcelas não confere com o valor total!
                </Typography>
                <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 'bold' }}>
                  Diferença: {formatarMoeda(Math.abs(diferenca))} {diferenca > 0 ? '(sobrando)' : '(faltando)'}
                </Typography>
              </Box>
            </Alert>
          )}

          {/* INDICADOR DE CONFERÊNCIA */}
          {Math.abs(diferenca) <= 0.0001 && lista.length > 0 && (
            <Alert
              severity="success"
              icon={<CheckCircleIcon />}
              sx={{
                mb: 2,
                borderRadius: 2,
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                ✅ Valores conferem! Total das parcelas é igual ao valor da nota.
              </Typography>
            </Alert>
          )}

          <Paper
            elevation={0}
            sx={{
              bgcolor: getCardBackgroundColor(),
              p: 2,
              borderRadius: 2,
              mb: 3,
              border: '1px solid',
              borderColor: getBorderColor(),
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '3px',
                background: 'linear-gradient(90deg, #1976D2 0%, #64B5F6 100%)'
              }
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <BasicSelect
                  name='pagamento'
                  label='Forma de Pagamento'
                  data={[
                    { nameBD: 'boleto', descricao: 'Boleto' },
                    { nameBD: 'carteira', descricao: 'Carteira' },
                    { nameBD: 'deposito', descricao: 'Depósito' },
                    { nameBD: 'debitoemconta', descricao: 'Débito em conta' },
                    { nameBD: 'pix', descricao: 'PIX' },
                  ]}
                  aoClicar={handleTipopagamento}
                  disabled={props.status === false ? isLoading : true}

                />
              </Grid>
              <Grid item xs={6} md={3}>
                <VTextFieldNumber
                  fullWidth
                  size='small'
                  name='numero'
                  label='Nº Documento'
                  disabled
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      bgcolor: getInputBackgroundColor(),
                      '& input': {
                        color: getTextColor()
                      }
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.mode === 'dark' ? '#AAA' : undefined
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <VFieldMoney
                  fullWidth
                  size='small'
                  name='venda'
                  label='Valor Total'
                  calcular={handleVnota}
                  disabled
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      bgcolor: getInputBackgroundColor(),
                      '& input': {
                        color: getTextColor()
                      }
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.mode === 'dark' ? '#AAA' : undefined
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6} md={2}>
                <VTextFieldNumber
                  fullWidth
                  size='small'
                  name='qtdparcelas'
                  label='Qtd Parcelas'
                  calcular={handleQtdParcelas}
                  disabled={props.status === false ? isLoading : true}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      bgcolor: getInputBackgroundColor(),
                      '& input': {
                        color: getTextColor()
                      }
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.mode === 'dark' ? '#AAA' : undefined
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 2,
            px: 0.5
          }}>
            <SplitscreenIcon sx={{ color: '#1976D2', fontSize: 20 }} />
            <DialogTitle
              sx={{
                p: 0,
                fontWeight: 600,
                fontSize: 18,
                color: getTextColor()
              }}
            >
              Parcelas
            </DialogTitle>
            <Chip
              label={`${lista.length} parcela(s)`}
              size="small"
              sx={{
                ml: 1,
                bgcolor: theme.palette.mode === 'dark' ? '#0D47A1' : '#E3F2FD',
                color: theme.palette.mode === 'dark' ? '#FFF' : '#1976D2',
                fontWeight: 500
              }}
            />
            <Chip
              label={`Total: ${formatarMoeda(lista.reduce((acc, item) => acc + item.vparcela, 0))}`}
              size="small"
              variant="outlined"
              sx={{
                ml: 1,
                borderColor: Math.abs(diferenca) > 0.0001 ? '#f44336' : '#4caf50',
                color: Math.abs(diferenca) > 0.0001 ? '#f44336' : '#4caf50',
                fontWeight: 500
              }}
            />
          </Box>
          <List sx={{ pt: 0, maxHeight: '350px', overflow: 'auto' }}>
            {lista.map((listItem) => (
              <ListItem
                key={listItem.idpagar}
                sx={{
                  mb: 1.5,
                  borderRadius: 2,
                  bgcolor: getCardBackgroundColor(),
                  border: '1px solid',
                  borderColor: theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.08)'
                    : 'rgba(0,0,0,0.05)',
                  boxShadow: theme.palette.mode === 'dark'
                    ? '0 2px 8px rgba(0,0,0,0.2)'
                    : '0 4px 12px rgba(0,0,0,0.03)',
                  p: 2,
                  transition: 'all 0.2s',
                  '&:hover': {
                    borderColor: '#1976D2',
                    boxShadow: theme.palette.mode === 'dark'
                      ? '0 8px 24px rgba(25, 118, 210, 0.3)'
                      : '0 8px 24px rgba(25, 118, 210, 0.12)'
                  }
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <CalendarMonthIcon sx={{ color: getIconColor(), fontSize: 18 }} />
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          format='DD/MM/YYYY'
                          value={dayjs(listItem.vencimento)}
                          label="Vencimento"
                          onChange={(newValue) => {
                            const inputValue = dayjs(newValue).format('YYYY-MM-DD');
                            handleInputChangeDate(listItem.idpagar, inputValue);
                          }}
                          slotProps={{
                            textField: {
                              size: 'small',
                              fullWidth: true,
                              sx: {
                                '& .MuiOutlinedInput-root': {
                                  bgcolor: getInputBackgroundColor(),
                                  '& input': {
                                    color: getTextColor()
                                  }
                                },
                                '& .MuiInputLabel-root': {
                                  color: theme.palette.mode === 'dark' ? '#AAA' : undefined
                                }
                              }
                            }
                          }}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Grid>

                  <Grid item xs={6} md={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <FormatListNumberedIcon sx={{ color: getIconColor(), fontSize: 18 }} />
                      <TextField
                        size='small'
                        value={listItem.parcela}
                        label="Parcela"
                        fullWidth
                        disabled
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            bgcolor: getInputBackgroundColor(),
                            '& input': {
                              color: getTextColor()
                            }
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.mode === 'dark' ? '#AAA' : undefined
                          }
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <AttachMoneyIcon sx={{ color: getIconColor(), fontSize: 18 }} />

                      {props.decimais === 4 ? (
                        <VFieldMoney4Faturamento
                          size="small"
                          id={listItem.idpagar}
                          valor={handleInputChange}
                          label="Valor da Parcela"
                          defaultValue={String(listItem.vparcela.toFixed(4))}
                          sx={{
                            flex: 1,
                            '& .MuiOutlinedInput-root': {
                              bgcolor: getInputBackgroundColor(),
                              '& input': {
                                color: getTextColor()
                              },
                              '&.Mui-focused': {
                                borderColor: '#1976D2'
                              }
                            },
                            '& .MuiInputLabel-root': {
                              color: theme.palette.mode === 'dark' ? '#AAA' : undefined
                            }
                          }}
                        />
                      ) : (
                        <VFieldMoney2Faturamento // 👈 seu componente de 2 casas
                          size="small"
                          id={listItem.idpagar}
                          valor={handleInputChange}
                          label="Valor da Parcela"
                          defaultValue={String(listItem.vparcela.toFixed(2))}
                          sx={{
                            flex: 1,
                            '& .MuiOutlinedInput-root': {
                              bgcolor: getInputBackgroundColor(),
                              '& input': {
                                color: getTextColor()
                              },
                              '&.Mui-focused': {
                                borderColor: '#1976D2'
                              }
                            },
                            '& .MuiInputLabel-root': {
                              color: theme.palette.mode === 'dark' ? '#AAA' : undefined
                            }
                          }}
                        />
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </ListItem>
            ))}
          </List>
        </VForm>
      </DialogContent>
      <DialogActions sx={{
        p: 2,
        bgcolor: getCardBackgroundColor(),
        borderTop: '1px solid',
        borderColor: theme.palette.mode === 'dark'
          ? 'rgba(255,255,255,0.08)'
          : 'rgba(0,0,0,0.05)',
        gap: 1
      }}>
        <Button
          variant='outlined'
          color='error'
          onClick={handleCancel}
          sx={{
            borderRadius: 1.5,
            px: 3,
            py: 0.75,
            textTransform: 'none',
            fontWeight: 500,
            borderWidth: 1.5,
            '&:hover': {
              borderWidth: 1.5
            }
          }}
        >
          Cancelar
        </Button>

        <Button
          variant='contained'
          autoFocus
          onClick={save}
          disabled={isConfirmDisabled || isSaving}
          sx={{
            px: 4,
            py: 0.75,
            borderRadius: 1.5,
            textTransform: 'none',
            fontWeight: 600,
            background: isConfirmDisabled ? undefined : getHeaderGradient(),
          }}
        >
          F9 Confirmar
        </Button>
      </DialogActions>
      </Dialog>
    </>
  );
};